import { useEffect, useState } from 'react';

export const useCart = () => {
  const [cart, setCart] = useState([]);

  const normalizeCart = (value) => {
    if (Array.isArray(value)) {
      return value;
    }
    if (value && Array.isArray(value.items)) {
      return value.items;
    }
    return [];
  };

  const getStoredCart = () => {
    const cartData = window.localStorage.getItem('cart');
    if (!cartData) {
      return [];
    }

    try {
      const parsed = JSON.parse(cartData);
      return normalizeCart(parsed);
    } catch (error) {
      return [];
    }
  };

  const addToCart = (product) => {
    const existingCart = getStoredCart();
    const updatedCart = [...existingCart, product];
    window.localStorage.setItem('cart', JSON.stringify(updatedCart));
    setCart(updatedCart);
  };

  const checkItemInCart = (id) => {
    const currentCart = getStoredCart();
    return currentCart.some((item) => item && item.id === id);
  };

  useEffect(() => {
    setCart(getStoredCart());
  }, []);

  const getCart = () => {
    return getStoredCart();
  };

  const clearCart = () => {
    window.localStorage.removeItem('cart');
    setCart([]);
  };

  const removeItem = (id) => {
    const currentCart = getStoredCart();
    const newCart = currentCart.filter((item) => item && item.id !== id);
    window.localStorage.setItem('cart', JSON.stringify(newCart));
    setCart(newCart);
  };

  return {
    cart,
    addToCart,
    getCart,
    clearCart,
    removeItem,
    checkItemInCart,
  };
};
